









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import AccessCar from './ItemAccessCar.vue';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {
        AccessCar,
        FormNavigationButtons,
    },
})
export default class StepAccessCars extends Vue {
    @Prop({
        default: () => {
            return Array();
        },
    })
    oldAccessCars!: FORM_INTERFACE.involvedPeopleInterface[];

    rules: any = rules;
    isFormValid: boolean = true;
    numberOfCars: number = 0;
    $refs!: {
        form: any;
        Car: any;
    };
    numberPlateForValidation: string = '';

    sendData() {
        let accessCars: FORM_INTERFACE.accessCarsInterface[] = Array();
        if (this.numberOfCars > 0) {
            this.$refs.Car.forEach(car => {
                accessCars.push(car.sendData());
            });
        }
        return { accessCars };
    }

    updateListData() {
        return false;
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.isFormValid = true;
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }

    numberOfCarsChanged() {
        if (this.numberOfCars < this.oldAccessCars.length) {
            this.oldAccessCars.splice(
                this.numberOfCars,
                this.oldAccessCars.length - this.numberOfCars,
            );
        }
    }

    validateNumberPlate(numberPlate: string) {
        this.numberPlateForValidation = numberPlate;
    }

    get getNumberPlate() {
        return this.numberPlateForValidation;
    }

    @Watch('oldAccessCars')
    assignOldValues(
        value: FORM_INTERFACE.involvedPeopleInterface[],
        oldValue: FORM_INTERFACE.involvedPeopleInterface[],
    ) {
        if (oldValue.length == undefined) {
            this.numberOfCars = this.oldAccessCars.length;
        }
    }
}
